// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);

// Local Storage
export const lsGetSettingByName = name => {
  const settings = localStorageGetObject('settings') || {};
  return settings[name];
};
export const lsSetSettingByName = (name, value) => {
  const settings = localStorageGetObject('settings') || {};
  settings[name] = value;
  localStorageSetItem('settings', settings);
};
export const lsRemoveSettingByName = name => {
  const settings = localStorageGetObject('settings') || {};
  if (settings[name]) delete settings[name];
  if (Object.keys(settings).length === 0 && settings.constructor === Object) {
    localStorageRemoveItem('settings');
  } else {
    localStorageSetItem('settings', settings);
  }
};
